import { useAppStateMachine } from '../../components/providers/app-state-machine-provider.tsx';

export const useAppState = () => {
    const { state } = useAppStateMachine();

    let salesRepId: string | undefined;
    if (state.context.platoUser?.showDataForErpSalesRepId && state.context.platoUser.erpSalesRepId) {
        salesRepId = state.context.platoUser.erpSalesRepId;
    }

    return {
        superAdmin: state.context.superAdmin,
        platoUser: state.context.platoUser,
        tenantId: state.context.tenantId,
        primaryUserType: state.context.primaryUserType,
        appIsLoading: state.context.appIsLoading,
        userIsLoading: state.context.userIsLoading,
        superAdminImpersonatingPlatoUserId: state.context.superAdminImpersonatingPlatoUserId,
        salesRepIds: state.context.platoUser?.salesRepIds ?? [],
        salesRepId,
    };
};
